import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, PropType, watch, nextTick, toRaw } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { walletBindUser } from '@/api/operation'
import { ElMessage } from 'element-plus'
import FormRulesFactory from '@/common/formRules'
import SelectUser from '@/components/SelectUser.vue'
import _ from 'lodash'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'BindUser',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  walletId: {
    type: String,
    required: true,
  },
  operatorId: {
    type: String,
    required: true,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const groupFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['userId'], 'inputEmpty', 'inputInvalid'),
})


const { t } = useI18n()




const formData = ref<Record<string, any>>({
  userId: '0',
  walletId: '0',
})

const formRef = ref()


const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const handleOpenDialog = () => {
  nextTick(() => {
    // 清空校验
    formRef.value.clearValidate()
  })
}


const submit = async () => {
  try {
    await formRef.value.validate()
    isSubmitting.value = true

    formData.value.walletId = props.walletId
    await walletBindUser({
      ...formData.value,
    })
    ElMessage.success(t(`Base.opSuccess`))
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "60%",
    class: "upsert-dialog",
    title: _unref(t)('Operation.bindUser'),
    "z-index": 2000,
    onOpen: handleOpenDialog
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: groupFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.user'),
                    prop: "userId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectUser, {
                        modelValue: formData.value.userId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.userId) = $event)),
                        operatorID: props?.operatorId
                      }, null, 8, ["modelValue", "operatorID"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})